import { useEffect } from "react";
import axios from "axios";
import HeroSection from "./HeroSection";
import KazakhstanMap from "./KazakhstanMap";
import API_BASE_URL from "../config/Config.js";
import NewsSection from "./NewsSection.jsx";
import ScrollToTopButton from "./ScrollToTopButton.jsx";
import ContactsSection from "./ContactsSection.jsx";
import TeamSection from "./TeamSection";
import PartnersSection from "./PartnersSection";
import { SectionTitle } from "./ui";

const branchLocations = [
  {
    title: "Главный офис",
    address: "г. Астана, улица Сафуан Шаймерденов, 8",
    href: "https://2gis.kz/astana/geo/70030076151014572/71.537497%2C51.112382",
  },
  {
    title: "Филиал в Караганде",
    address: "г. Караганда, улица Керамическая, 4/6",
    href: "https://2gis.kz/karaganda/search/Караганда%2C%20улица%20Керамическая%2C%204%2F6",
  },
];

export default function HomePage() {
  useEffect(() => {
    const hash = sessionStorage.getItem("scrollToHash");
    if (hash) {
      const el = document.getElementById(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
          sessionStorage.removeItem("scrollToHash");
        }, 100);
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .post(
          `${API_BASE_URL}/auth/validate`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const name =
            res?.data?.data?.username || res?.data?.data?.user?.username;
          localStorage.setItem("username", name);
        })
        .catch((err) => {
          console.error("Ошибка валидации токена:", err);
          localStorage.removeItem("token");
          localStorage.removeItem("username");
        });
    }
  }, []);

  return (
    <main className="bg-dark-50">
      <ScrollToTopButton />

      {/* Hero Section */}
      <HeroSection />

      {/* News Section */}
      <section
        id="news"
        className="relative py-20 md:py-28 bg-gradient-to-b from-dark-50 to-white"
      >
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-dark-900/5 to-transparent" />
        <div className="absolute top-20 right-0 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            subtitle="Будьте в курсе"
            title="Последние новости"
            description="Узнайте о наших проектах, мероприятиях и достижениях"
            className="mb-12"
          />
          <NewsSection />
        </div>
      </section>

      {/* Map Section */}
      <section
        id="map"
        className="relative py-20 md:py-28 bg-gradient-to-b from-white to-dark-50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            subtitle="География"
            title="Наши филиалы"
            description="Мы присутствуем в ключевых регионах Казахстана"
            className="mb-12"
          />

          {/* Desktop Map */}
          <div className="hidden md:block">
            <KazakhstanMap />
          </div>

          {/* Mobile Info */}
          <div className="grid gap-4 md:hidden px-4">
            {branchLocations.map((branch) => (
              <div
                key={branch.title}
                className="w-full p-6 bg-white rounded-2xl shadow-card text-center"
              >
                <div className="w-12 h-12 mx-auto mb-4 bg-primary-100 rounded-xl flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-primary-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-dark-900 mb-2">
                  {branch.title}
                </h3>
                <p className="text-dark-500 mb-4">{branch.address}</p>
                <a
                  href={branch.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-primary-500 to-teal-500 text-white font-semibold rounded-xl shadow-lg"
                >
                  Открыть в 2ГИС
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section
        id="team"
        className="relative py-20 md:py-28 bg-gradient-to-b from-dark-50 to-white"
      >
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" />
        <TeamSection />
      </section>

      {/* Partners Section */}
      <PartnersSection />

      {/* Contacts Section */}
      <ContactsSection />
    </main>
  );
}
